import ComAppTopTip from './AppTip/AppTopTip.vue'
import ComWaiting from './Waitting/waiting.vue'
import ComToast from './com_toast'
import comBack from './comBack/comBack.vue'


var components = {
  install: function(Vue){
    Vue.component('ComAppTopTip',ComAppTopTip)
    Vue.component('ComWaiting',ComWaiting)
    Vue.component('ComToast',ComToast)
    Vue.component('comBack',comBack)
  }
}

export default components



// WEBPACK FOOTER //
// ./src/components/index.js